import React, {FormEvent, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {ApiClient} from "@/api/ApiClient";
import {FtFormItem} from "@/FtStyle";
import {ErrorUtil} from "@/utils/ErrorUtil";
import {FtButton} from "@/common/FtButton";

export function LoginPage() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | undefined>();

    const navigate = useNavigate();
    const location = useLocation();

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();

        setIsLoading(true);
        setError(undefined);

        try {
            await ApiClient.instance.login(username, password);
            const from = location.state?.from?.pathname || "/";
            navigate(from, {replace: true});
        } catch (error) {
            setError("로그인 실패: " + ErrorUtil.getErrorMessage(error));
            console.error("Login failed:", error);
        }
        setIsLoading(false);
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            }}
        >
            <div style={{width: 240, marginTop: 64}}>
                <form onSubmit={handleSubmit}>
                    <FtFormItem>
                        <label>Username</label>

                        <input
                            required
                            id="username"
                            name="username"
                            autoComplete="username"
                            autoFocus
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </FtFormItem>

                    <FtFormItem>
                        <label>Password</label>
                        <input
                            required
                            name="password"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </FtFormItem>

                    <FtButton type="submit"
                              disabled={isLoading}
                              style={{display: 'block', width: '100%'}}>
                        {isLoading ? 'Logging in...' : 'Login'}
                    </FtButton>

                    {error && <p style={{color: 'red', marginTop: '10px'}}>{error}</p>}
                </form>
            </div>
        </div>
    );
}
